/* eslint-disable */

const usersFields = [
  { key: 'firstName', label: 'First Name', sortable: true },
  { key: 'lastName', label: 'Last Name', sortable: true },
  { key: 'email', label: 'Email', sortable: true },
  { key: 'roles', label: 'Roles', sortable: true },
  { key: 'externalId', label: 'Diamond', sortable: true },
  { key: 'customerShops'},
  { key: 'confirmationSent', label: 'Confirmed', sortable: true },
  { key: 'state', label: 'Status', sortable: true },
  { key: 'Actions', class: 'align-top table-action-column' },
];

const stateDeleted = 'DELETED';
const defaultAccessRight = 'FORBIDDEN';

const accessRights = [defaultAccessRight, 'READ', 'WRITE'];


export const constants = {
  usersFields,
  stateDeleted,
  defaultAccessRight,
  accessRights
};